import {Component, Inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {
    InventoryControllerService,
    ProductDistributorDto,
    ProductDocumentDto,
    ProductDto,
    ProductHighlightDto,
    ProductOverviewDto,
    ProductSpecificationDto
} from '../../../@api';
import {MessagingHandlerService} from '../../../common/response-messaging-handler/messaging-handler.service';
import {DOCUMENT} from '@angular/common';
import {NgForm} from "@angular/forms";

interface ProductMetaDto {
    id: number;
    label: string;
    value: string;
}

@Component({
    selector: 'app-maintain-product',
    templateUrl: './maintain-product.component.html',
    styleUrls: ['./maintain-product.component.scss']
})
export class MaintainProductComponent implements OnInit, OnChanges {

    @ViewChild('newProductForm') newProductForm: NgForm;
    
    @Input() product: ProductDto = undefined;
    meta: ProductMetaDto[] = [];

    constructor(@Inject(DOCUMENT) private document: Document,
                private inventoryControllerService: InventoryControllerService,
                private messagingHandlerService: MessagingHandlerService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.product) {
            this.meta = [];
            this.meta.push({id: this.product.id, label: 'Title', value: this.product.title});
            this.meta.push({id: this.product.id, label: 'Keywords', value: this.product.keywords});
            this.meta.push({id: this.product.id, label: 'Description', value: this.product.description});
            this.meta.push({id: this.product.id, label: 'root', value: this.product.root});

            if (this.product.id < 1) {
                this.addNewDistributorLine(this.product.distributors);
            }
        }
    }

    async ngOnInit() {
    }

    submit(): void {
        let request: ProductDto = Object.assign({}, this.product);
        request.title = this.meta[0].value;
        request.keywords = this.meta[1].value;
        request.description = this.meta[2].value;
        request.root = this.meta[3].value;

        this.inventoryControllerService.saveProduct(request).subscribe((response: ProductDto): void => {
            this.product = response;
            this.messagingHandlerService.showSuccess('Product submitted successfully', 'Product Maintenance');
        }, error => {
            console.log(error);
            this.messagingHandlerService.showError('Unable to submit product', 'Product Maintenance');
        });
    }

    addNewOverview(overviews: ProductOverviewDto[]): void {
        (overviews || []).push({id: 0, html: 'Click to edit'});
        this.product.overviews = overviews;
    }

    addNewHighlightLine(highlights: ProductHighlightDto[]): void {
        (highlights || []).push({id: 0, label: 'Label', value: 'Value'});
        this.product.highlights = highlights;
    }

    removeHighlightLine(highlight: ProductHighlightDto): void {
        highlight.deleted = true;
    }

    addNewSpecLine(specifications: ProductSpecificationDto[]): void {
        (specifications || []).push({id: 0, label: 'Label', value: 'Value'});
        this.product.specifications = specifications;
    }

    removeSpecLine(specification: ProductSpecificationDto): void {
        specification.deleted = true;
    }

    addNewDocumentLine(documents: ProductDocumentDto[]): void {
        (documents || []).push({id: 0, description: 'New Document', url: 'https://www.solarcentral.co.za/pdf/'});
        this.product.documents = documents;
    }

    removeDocumentLine(document: ProductDocumentDto): void {
        document.deleted = true;
    }

    addNewDistributorLine(distributors: ProductDistributorDto[]): void {
        (distributors || []).push(
            {
                id: 0,
                distributor: 'GC Solar | SolarWay',
                distributorClient: undefined,
                refreshUrl: 'https://onlineshop.gcsolar.co.za/product/',
                code: this.product.code,
                sku: undefined,
                cost: undefined,
                retail: 999.99,
                markup: undefined,
                inventoryStatus: 'N/A'
            });
        this.product.distributors = distributors;
    }

    removeDistributorLine(distributor: ProductDistributorDto): void {
        distributor.deleted = true;
    }

    test(record: ProductDistributorDto): void {
        this.inventoryControllerService.refreshProduct(record).subscribe((response: ProductDistributorDto): void => {
            record.inventoryStatus = response.inventoryStatus;
            record.retail = response.retail;
            this.product.price = record.retail;

            this.productDistributionRecordCostChanged(record);
        }, error => {
            console.log(error);
        });
    }

    productCodeChanged($event: any): void {
        this.product.image = 'https://www.solarcentral.co.za/images/' + $event + '.png';
        this.product.longName = this.product.name + ' (' + $event + ')';
        let distributors: ProductDistributorDto[] = [].concat(this.product.distributors);
        distributors.forEach((p: ProductDistributorDto) => p.code = $event);
        this.product.distributors = distributors;

        console.log(JSON.stringify(this.product));
    }

    productNameChanged($event: any): void {
        let title: ProductMetaDto = this.meta.filter((f: ProductMetaDto): boolean => f.label === 'Title')[0];
        title.value = 'Solar Central | Products | ' + $event;

        let keywords: ProductMetaDto = this.meta.filter((f: ProductMetaDto): boolean => f.label === 'Keywords')[0];
        keywords.value = this.product.keywords + ', ' + $event.replace(/\s/g, ',');
    }

    metaRecordValueChanged($event: any, record: ProductMetaDto): void {
        if (record.label === 'root') {
            this.product.distributors[0].refreshUrl = 'https://onlineshop.gcsolar.co.za/product/' + $event + '/';
        }
    }

    productDistributionRecordCostChanged(record: ProductDistributorDto): void {
        if (record['retail'] && record['cost']) {
            let amountMargin: number = record['retail'] - record['cost'];
            let profitMargin: number = Number((amountMargin / record['retail']).toFixed(3));
            record['markup'] = profitMargin;
        }
    }
}
